import moment from "moment";
import { useRef, useState } from "react";
import { toast } from "react-toastify";
import useAxiosClient from "../useAxiosClient";
import { useDispatch, useSelector } from "react-redux";
import {
  setArrivalUpdated,
  updateTradeDetailsById,
} from "../../reducers/tradeDetail_byId_slice";
import { TRootState } from "../../store";
import {
  arrivalDetails,
  setArrivalDocuments,
  setArrivalWeightDocuments,
  setPattiDocuments,
  udpateAddArrival,
} from "../../reducers/arrivalDetails_slice";
import isArrivalDateStatus from "../../helpers/getArrivalDateStatus";
import {
  TCrop,
  TRatePerTypes,
  TTradeDocument,
} from "../../types/trades/trades";
import { fixedDigitNumber } from "../../helpers/get-currency-number";
import { numberPrecision, validateTruckNumber } from "../../helpers/getText";
import { setRefreshMovePmt } from "../../reducers/trade_details_Slice";
import {
  getArrivalIndFreightRate,
  getIndFreightCost,
  getIndFreightRateUnitWeight,
  getIndLandingInvoiceCost,
  getIndLandingRate,
  getIndSpotCommodityCost,
  getIndSpotRate,
  getIndWeight,
  getTotalFreightCostAmt,
  roundOffNum,
  toNum,
} from "../../helpers/trade";
import { setCropLineItems } from "../../reducers/dispatchDetail_slice";

const useArrivalDetails = ({ mode }: { mode?: string }) => {
  const { handlePutCall, handlePostCall } = useAxiosClient();
  const dispatch = useDispatch();

  const {
    tradeDetailsbyId,
    traderId,
    arlDate,
    adminId,
    role,
    paymentHistoryObj,
    addArrivalDetails,
    arrival,
    arrivalWight,
    patti,
    cropLineItems,
  } = useSelector((state: TRootState) => ({
    tradeDetailsbyId: state.tradeDetailsById.tradeDetailsbyId,
    traderId: state.tradeDetails.traderId,
    arlDate: state.tradeDetailsById?.tradeDetailsbyId?.arlDate,
    adminId: state.auth.adminId,
    role: state.auth.userInfo?.roleType,
    paymentHistoryObj: state.arrivalDetails.paymentHistoryObj,
    addArrivalDetails: state.arrivalDetails.addArrivalDetails,
    arrival: state.arrivalDetails.arrivalDocs.arrival,
    arrivalWight: state.arrivalDetails.arrivalDocs.arrivalWight,
    patti: state.arrivalDetails.arrivalDocs.patti,
    cropLineItems: state.dispatchDetails.cropLineItems,
  }));

  const calculateAdvancePaid = () => {
    let sum = 0;
    if (tradeDetailsbyId != null) {
      if (tradeDetailsbyId?.pmtHistory.length > 0) {
        for (let item of tradeDetailsbyId?.pmtHistory) {
          if (
            item.pmtType.toUpperCase() == "ADVANCE" &&
            item.inOutWard === "INWARD" &&
            (item.pmtStatus === "ACCEPTED" || item.pmtStatus === "PENDING")
          ) {
            sum += item.amount;
          }
        }
      }
    }
    return sum;
  };
  const calculateAdvancePaidSrc = () => {
    let sum = 0;
    if (tradeDetailsbyId != null) {
      if (tradeDetailsbyId?.pmtHistory.length > 0) {
        for (let item of tradeDetailsbyId?.pmtHistory) {
          if (
            item.pmtType.toUpperCase() === "ADVANCE" &&
            item.inOutWard === "OUTWARD" &&
            (item.pmtStatus === "ACCEPTED" || item.pmtStatus === "PENDING")
          ) {
            sum += item.amount;
          }
        }
      }
    }
    return sum;
  };

  const [reqAdvInfo, setReqAdvInfo] = useState<{
    advLimit: number | "";
    requestAdv: number | "";
    advDate: string;
    comments: string;
    advDisb: number;
    advApproved: number;
    disbDate: string;
    status: number;
    srcOtp: string;
  }>({
    advLimit: tradeDetailsbyId?.reqAdv?.advLimit || 0,
    requestAdv: tradeDetailsbyId?.reqAdv?.requestAdv || 0,
    advDate:
      tradeDetailsbyId?.reqAdv?.advDate == "" ||
      tradeDetailsbyId?.reqAdv?.advDate == null
        ? moment(new Date()).format("YYYY-MM-DD")
        : moment(new Date(tradeDetailsbyId?.reqAdv?.advDate!)).format(
            "YYYY-MM-DD"
          ),
    comments: tradeDetailsbyId?.reqAdv?.comments || "",
    advDisb: tradeDetailsbyId?.reqAdv?.advDisb || 0,
    advApproved: tradeDetailsbyId?.reqAdv?.advApproved || 0,
    disbDate: tradeDetailsbyId?.reqAdv?.disbDate || "",
    status:
      tradeDetailsbyId?.reqAdv != null
        ? tradeDetailsbyId?.reqAdv?.status == 1
          ? 2
          : tradeDetailsbyId?.reqAdv?.status || 1
        : 1,
    srcOtp: "",
  });

  const [calenderOpen, setCalenderOpen] = useState(false);

  const onUploadReceiptImage1 = async (
    type: "TRANSPORT_PAYMENT" | "ARRIVAL_WEIGHT_BRIDGE" | "PATTI",
    file: FileList | File[]
  ) => {
    const uploadPromises = Array.from(file).map(async (file) => {
      let fileType: "pdf" | "image";
      if (file.type === "application/pdf") {
        fileType = "pdf";
      } else if (file.type.includes("image/")) {
        fileType = "image";
      } else {
        return;
      }

      let formdata = new FormData();
      formdata.append("traderId", traderId.toString());
      formdata.append("file", file, file.name.replace(" ", "-"));
      let imageUploadResponse = await handlePostCall<string[]>({
        URL: "/mandi/files/trade-portal/imgs/upload",
        apiParams: formdata,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      });
      let url = imageUploadResponse.data[0];
      const newDocument: TTradeDocument = {
        docType: fileType,
        url,
        id: 0,
        reqId: tradeDetailsbyId?.tradeId!,
        tradeId: 0,
        imgFrom: "",
        type,
        status: 1,
        typeId: 0,
      };
      if (type === "TRANSPORT_PAYMENT") {
        const updatedArrival: TTradeDocument[] = [...arrival, newDocument];
        dispatch(setArrivalDocuments(updatedArrival));
      } else if (type === "ARRIVAL_WEIGHT_BRIDGE") {
        const updatedArrivalWeight: TTradeDocument[] = [
          ...arrivalWight,
          newDocument,
        ];
        dispatch(setArrivalWeightDocuments(updatedArrivalWeight));
      } else if (type === "PATTI") {
        const updatedPatti: TTradeDocument[] = [...patti, newDocument];
        dispatch(setPattiDocuments(updatedPatti));
      }
    });
    await Promise.all(uploadPromises);
  };

  const onRemoveReceiptImage1 = (
    type: "TRANSPORT_PAYMENT" | "ARRIVAL_WEIGHT_BRIDGE" | "PATTI",
    index: number,
    isExist: boolean = false
  ) => {
    if (type === "TRANSPORT_PAYMENT") {
      let updatedTapalDocs = [...arrival];
      updatedTapalDocs.splice(index, 1);
      let invoices = [...tradeDetailsbyId?.arrivalDocs!];
      let i = invoices.findIndex((img) => img.id === index);
      invoices[i] = { ...invoices[i], status: 0 };
      dispatch(
        updateTradeDetailsById({
          tradeDetailsbyId: {
            ...tradeDetailsbyId!,
            arrivalDocs: invoices,
          },
        })
      );
      dispatch(setArrivalDocuments(updatedTapalDocs));
    } else if (type === "ARRIVAL_WEIGHT_BRIDGE") {
      let updatedReceiptDocs = [...arrivalWight];
      updatedReceiptDocs.splice(index, 1);
      let invoices = [...tradeDetailsbyId?.arrivalWeightDocs!];
      let i = invoices.findIndex((img) => img.id === index);
      invoices[i] = { ...invoices[i], status: 0 };
      dispatch(
        updateTradeDetailsById({
          tradeDetailsbyId: {
            ...tradeDetailsbyId!,
            arrivalWeightDocs: invoices,
          },
        })
      );
      dispatch(setArrivalWeightDocuments(updatedReceiptDocs));
    } else if (type === "PATTI") {
      let updatedOtherDocs = [...patti];
      updatedOtherDocs.splice(index, 1);
      let invoices = [...tradeDetailsbyId?.pattiDocs!];
      let i = invoices.findIndex((img) => img.id === index);
      invoices[i] = { ...invoices[i], status: 0 };
      dispatch(
        updateTradeDetailsById({
          tradeDetailsbyId: {
            ...tradeDetailsbyId!,
            pattiDocs: invoices,
          },
        })
      );
      dispatch(setPattiDocuments(updatedOtherDocs));
    }
  };

  const [isArrivalEdit, setIsArrivalEdit] = useState(false);
  const [pattiDocsEdit, setPattiDocsEdit] = useState(false);
  const updateTapalInvEditStatus = () => {
    let isUpdate = false;

    if (tradeDetailsbyId?.arlDate != addArrivalDetails?.arlDate) {
      isUpdate = true;
    } else if (tradeDetailsbyId?.arlTime != addArrivalDetails?.arlTime) {
      isUpdate = true;
    } else if (
      tradeDetailsbyId?.commodityCost != addArrivalDetails?.cmdityCost
    ) {
      isUpdate = true;
    } else if (tradeDetailsbyId?.invAmt != addArrivalDetails?.invAmt) {
      isUpdate = true;
    } else if (tradeDetailsbyId?.misc != addArrivalDetails?.misc) {
      isUpdate = true;
    } else if (
      tradeDetailsbyId?.freightPaid != addArrivalDetails?.freightPaid
    ) {
      isUpdate = true;
    } else if (tradeDetailsbyId?.lineItems.length > 0) {
      let lineItem = tradeDetailsbyId.lineItems[0];
      if (lineItem.destWeight != addArrivalDetails?.destWeight) {
        isUpdate = true;
      } else if (lineItem.rate != addArrivalDetails?.rate) {
        isUpdate = true;
      } else if (lineItem.landingRate != addArrivalDetails?.destRate) {
        isUpdate = true;
      } else if (lineItem.addWastage != addArrivalDetails?.destWastage) {
        isUpdate = true;
      }
    }
    return isUpdate;
  };
  const updateArrivalData = () => {
    let arrrivalDate = new Date(addArrivalDetails?.arlDate!);

    let tradeDate = moment(tradeDetailsbyId?.date).format("YYYY-MM-DD");
    let date3 = new Date(tradeDate);
    if (arrrivalDate.getTime() < date3.getTime()) {
      toast.error(`Arrivals date can not be prior to the dispatch date.`);
      return;
    }
    var valueDay = isArrivalDateStatus(addArrivalDetails?.arlDate, tradeDate);
    if (!valueDay) {
      toast.error(
        `Arrival Date cannot be beyond 7 days from Trade Order dispatched Date.`,
        {
          toastId: "error6",
        }
      );
      return;
    }

    // if (!validateTruckNumber(addArrivalDetails.destVehNum)) {
    //   toast.error("Invalid truck number format");
    //   return;
    // }

    const lineItems = cropLineItems || [];
    if (lineItems.length > 0) {
      for (let i = 0; i < lineItems.length; i++) {
        const item = lineItems[i];
        if (item?.destQty == 0) {
          toast.error("Please enter destination Quantity ");
          return;
        }
        if (item?.destWeight == 0) {
          toast.error("Please enter destination Weight ");
          return;
        }

        if ((item?.destQty ?? 0) > item?.qty) {
          toast.error(
            "Destination Quantity values cannot exceed source Quantity values"
          );
          return;
        }

        if (item?.destWeight > item?.weight) {
          toast.error(
            "Destination Weight values cannot exceed source Weight values"
          );
          return;
        }
        //  if (addArrivalDetails?.netWeight == 0) {
        //    toast.error("Please enter Net Weight ");
        //    return;
        //  }
        //  if (addArrivalDetails?.destWastage! > addArrivalDetails?.destWeight!) {
        //    toast.error("Wastage should be less than Weight at Destination");
        //    return;
        //  }
        //  if (addArrivalDetails?.netWeight! > addArrivalDetails?.destWeight!) {
        //    toast.error("Net Weight should be less than Weight at Destination");
        //    return;
        //  }
      }
    }

    // if (
    //   addArrivalDetails?.destRate == 0 &&
    //   tradeDetailsbyId?.tradeMode == "ORDER"
    // ) {
    //   toast.error("Please enter Final Rate ");
    //   return;
    // }

    if (
      addArrivalDetails?.freightPaid !== 0 &&
      addArrivalDetails?.freightAmt !== 0
    ) {
      if (
        Number(addArrivalDetails?.freightPaid) >
        Number(addArrivalDetails?.freightAmt)
      ) {
        toast.error("Entered Freight Paid less than the Freight Amount");
        return;
      }
    }
    if (arrrivalDate.getTime() < date3.getTime()) {
      toast.error(`Arrival date can not be prior to the dispatch date.`);
      return;
    }

    let imgs: Array<{
      id: number;
      imgFrom: string;
      reqId: number;
      status: number;
      addedBy: number;
      type:
        | "TAPAL_INVOICE"
        | "WEIGH_BRIDGE"
        | "OTHER"
        | "TRANSPORT_PAYMENT"
        | "PATTI"
        | "PAYMENT"
        | "ARRIVAL_WEIGHT_BRIDGE";
      url: string;
    }> = [];
    let arrivalImages = imgs;
    if (arrival.length > 0) {
      for (let file of arrival) {
        arrivalImages.push({
          id: 0,
          imgFrom: "DEST_TRADER",
          reqId: tradeDetailsbyId?.tradeId!,
          status: 1,
          addedBy: traderId || 0,
          type: "TRANSPORT_PAYMENT",
          url: file.url,
        });
      }
    } else {
      if (tradeDetailsbyId != null) {
        if (tradeDetailsbyId?.arrivalDocs.length > 0) {
          for (let file of tradeDetailsbyId?.arrivalDocs) {
            if (file.status == 0) {
              arrivalImages.push({
                ...file,
                addedBy: traderId,
              });
            }
          }
        }
      }
    }
    if (arrivalWight.length > 0) {
      for (let file of arrivalWight) {
        arrivalImages.push({
          id: 0,
          imgFrom: "DEST_TRADER",
          reqId: tradeDetailsbyId?.tradeId!,
          status: 1,
          addedBy: traderId || 0,
          type: "ARRIVAL_WEIGHT_BRIDGE",
          url: file.url,
        });
      }
    } else {
      if (tradeDetailsbyId != null) {
        if (tradeDetailsbyId?.arrivalWeightDocs.length > 0) {
          for (let file of tradeDetailsbyId?.arrivalWeightDocs) {
            if (file.status == 0) {
              arrivalImages.push({
                ...file,
                addedBy: traderId,
              });
            }
          }
        }
      }
    }

    let postBody = {};
    let totalPayable =
      addArrivalDetails?.invAmt -
      calculateAdvancePaidSrc() -
      addArrivalDetails?.freightPaid -
      Number(tradeDetailsbyId?.srcDisc);
    let totalReceivable =
      addArrivalDetails?.invAmt -
      calculateAdvancePaid() -
      addArrivalDetails?.freightPaid -
      Number(tradeDetailsbyId?.destDisc);
    postBody = {
      adminId: adminId,
      arlConf: {
        arlDate: addArrivalDetails?.arlDate,
        freightPaid: tradeDetailsbyId?.freightDtls?.paidTo !== 'ONO'
         ? addArrivalDetails?.freightPaid
        : 0,
        images: arrivalImages,
        arlTime: addArrivalDetails?.arlTime
          ? addArrivalDetails?.arlTime
          : new Date().toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            }),
        comments: addArrivalDetails?.arlComments,
        addWastage: addArrivalDetails?.destWastage,
        destWeight: addArrivalDetails?.destWeight,
        tradeId: tradeDetailsbyId?.tradeId,
        destTradeStatus:
          tradeDetailsbyId?.progress[0].progState !== "ARL_CONFIRMED"
            ? "ARL_CONFIRMED"
            : tradeDetailsbyId?.destTradeStatus,
        landingRate: addArrivalDetails?.destRate,
        invAmt:
          tradeDetailsbyId?.tradeMode === "ORDER"
            ? addArrivalDetails?.invAmt
            : "",
        totalPayable: totalReceivable,
        totalReceivable: totalPayable,
        destVehNum: addArrivalDetails?.destVehNum || "",
        cmdityCost:
          tradeDetailsbyId?.tradeMode === "ORDER"
            ? addArrivalDetails?.cmdityCost
            : "",
        finalPayable: tradeDetailsbyId?.finalPayable,
        finalReceivable: tradeDetailsbyId?.finalReceivable,
        rate: addArrivalDetails?.rate,
        update: updateTapalInvEditStatus(),
        destDriverMobile: addArrivalDetails?.driverMobile,
        destDriverName: addArrivalDetails?.driverName,
        lineItems: cropLineItems.map((item, i) => {
          return {
            id: item.id,
            destWeight: item?.destWeight,
            destQty: item.destQty,
            addWastage: 0,
            cmdityCost:
              tradeDetailsbyId?.tradeMode === "ORDER" ? item.cmdityCost : "",
            rate: item.rate,
            landingRate: item.landingRate,
            weightUnit: item.unitType,
          };
        }),
      },
      tradeId: tradeDetailsbyId?.tradeId,
      tradeMode: tradeDetailsbyId?.tradeMode,
    };

    handlePutCall({
      URL: "admin/trade-platform/trades/metadata",
      apiParams: postBody,
    })
      .then(({ data, status }) => {
        toast.success(status.message);
        setIsArrivalEdit(false);
        dispatch(setArrivalUpdated(true));
        dispatch(setRefreshMovePmt(true));
      })
      .catch(() => {});
  };
  const getQtyWeightVal = () => {
    let qtyWeightVal = 0;
    if (addArrivalDetails != null) {
      if (addArrivalDetails?.weightUnit == "RATE_PER_UNIT") {
        qtyWeightVal = Number(addArrivalDetails.qty);
      } else if (addArrivalDetails?.weightUnit == "RATE_PER_KG") {
        qtyWeightVal = Number(addArrivalDetails.netWeight);
      }
    }
    return qtyWeightVal;
  };

  const onUpdateArrivalInput = (type: string, value: any) => {
    let arrivalData = addArrivalDetails;

    if (type === "VEHICLENUM") {
      arrivalData = {
        ...arrivalData,
        destVehNum: value,
      };
    } else if (type === "FREIGHTPAID") {
      arrivalData = {
        ...arrivalData,
        freightPaid: Number(value),
      };
    } else if (type === "DESTWEIGHT") {
      let destWeight = value !== "" ? parseFloat(value) : "";
      let netWeight = Number(value) - Number(arrivalData?.destWastage);
      let commodityCost;
      let invoice;
      let landingRate = arrivalData?.destRate;
      let rate = arrivalData?.rate;
      if (arrivalData?.rateType == "SPOT") {
        commodityCost =
          arrivalData != null
            ? arrivalData?.weightUnit === "RATE_PER_UNIT"
              ? Number(arrivalData?.rate) * Number(arrivalData?.qty)
              : netWeight * Number(arrivalData?.rate)
            : "";
        invoice =
          Number(commodityCost) +
          Number(arrivalData?.freightAmt) +
          Number(arrivalData?.misc);
        landingRate = numberPrecision(
          invoice /
            (arrivalData?.weightUnit == "RATE_PER_UNIT"
              ? Number(arrivalData?.qty)
              : netWeight)
        );
      } else if (arrivalData?.rateType == "LANDING") {
        invoice =
          arrivalData != null
            ? arrivalData?.weightUnit === "RATE_PER_UNIT"
              ? Number(arrivalData?.destRate) * Number(arrivalData?.qty)
              : netWeight * Number(arrivalData?.destRate)
            : "";
        commodityCost =
          Number(invoice) -
          Number(arrivalData?.freightAmt) -
          Number(arrivalData?.misc);

        rate = Number(
          Number(commodityCost) /
            (arrivalData?.weightUnit == "RATE_PER_UNIT"
              ? Number(arrivalData?.qty)
              : netWeight)
        );
      }

      arrivalData = {
        ...arrivalData,
        destWeight: Number(destWeight),
        netWeight: netWeight,
        cmdityCost:
          Number(commodityCost) > 0
            ? fixedDigitNumber(commodityCost)
            : Number(commodityCost),
        invAmt:
          Number(invoice) > 0 ? fixedDigitNumber(invoice) : Number(invoice),
        moistureLoss:
          Number(destWeight) > 0
            ? Number(arrivalData?.srcWeight) - Number(destWeight)
            : 0,
        destRate:
          Number(landingRate) > 0
            ? numberPrecision(landingRate)
            : Number(landingRate),
        rate: Number(rate) > 0 ? numberPrecision(rate) : Number(rate),
      };
    } else if (type === "ADDIWASTAGE") {
      let netWeight = Number(arrivalData?.destWeight) - Number(value);
      let commodityCost;
      let invoice;
      let landingRate = arrivalData?.destRate;
      let rate = arrivalData?.rate;
      if (arrivalData?.rateType == "SPOT") {
        commodityCost =
          arrivalData != null
            ? arrivalData?.weightUnit === "RATE_PER_UNIT"
              ? Number(arrivalData?.rate) * Number(arrivalData?.qty)
              : netWeight * Number(arrivalData?.rate)
            : "";
        invoice =
          Number(commodityCost) +
          Number(arrivalData?.freightAmt) +
          Number(arrivalData?.misc);
        landingRate = numberPrecision(
          invoice /
            (arrivalData?.weightUnit == "RATE_PER_UNIT"
              ? Number(arrivalData?.qty)
              : netWeight)
        );
      } else if (arrivalData?.rateType == "LANDING") {
        invoice =
          arrivalData != null
            ? arrivalData?.weightUnit === "RATE_PER_UNIT"
              ? Number(arrivalData?.destRate) * Number(arrivalData?.qty)
              : netWeight * Number(arrivalData?.destRate)
            : "";
        commodityCost =
          Number(invoice) -
          Number(arrivalData?.freightAmt) -
          Number(arrivalData?.misc);
        rate = Number(
          Number(commodityCost) /
            (arrivalData?.weightUnit == "RATE_PER_UNIT"
              ? Number(arrivalData?.qty)
              : netWeight)
        );
      }

      let destWastage = value !== "" ? parseFloat(value) : "";
      arrivalData = {
        ...arrivalData,
        netWeight: netWeight,
        cmdityCost:
          Number(commodityCost) > 0
            ? fixedDigitNumber(commodityCost)
            : Number(commodityCost),
        invAmt:
          Number(invoice) > 0 ? fixedDigitNumber(invoice) : Number(invoice),
        destWastage: Number(destWastage),
        destRate:
          Number(landingRate) > 0
            ? numberPrecision(landingRate)
            : Number(landingRate),
        rate: Number(rate) > 0 ? numberPrecision(rate) : Number(rate),
      };
    } else if (type === "NETWEIGHT") {
      let commodityCost;
      let invoice;
      let landingRate = arrivalData?.destRate;
      let rate = arrivalData?.rate;
      if (arrivalData?.rateType == "SPOT") {
        commodityCost =
          arrivalData != null
            ? arrivalData?.weightUnit == "RATE_PER_UNIT"
              ? Number(arrivalData?.rate) * Number(arrivalData?.qty)
              : parseFloat(value) * Number(arrivalData?.rate)
            : "";
        invoice =
          Number(commodityCost) +
          Number(arrivalData?.freightAmt) +
          Number(arrivalData?.misc);
        landingRate = fixedDigitNumber(
          invoice /
            (arrivalData?.weightUnit == "RATE_PER_UNIT"
              ? Number(arrivalData?.qty)
              : parseFloat(value))
        );
      } else if (arrivalData?.rateType == "LANDING") {
        invoice =
          arrivalData != null
            ? arrivalData?.weightUnit == "RATE_PER_UNIT"
              ? Number(arrivalData?.destRate) * Number(arrivalData?.qty)
              : parseFloat(value) * Number(arrivalData?.destRate)
            : "";
        commodityCost =
          Number(invoice) -
          Number(arrivalData?.freightAmt) -
          Number(arrivalData?.misc);
        rate = fixedDigitNumber(
          Number(commodityCost) /
            (arrivalData?.weightUnit == "RATE_PER_UNIT"
              ? Number(arrivalData?.qty)
              : parseFloat(value))
        );
      }

      let destWastage = Number(arrivalData?.destWeight) - Number(value);
      let netWeight = value !== "" ? parseFloat(value) : "";

      arrivalData = {
        ...arrivalData,
        destWastage: destWastage,
        netWeight: Number(netWeight),
        cmdityCost:
          Number(commodityCost) > 0
            ? numberPrecision(commodityCost)
            : Number(commodityCost),
        invAmt: Number(invoice),
        destRate: Number(landingRate),
        rate: Number(rate),
      };
    } else if (type === "SPOTRATE") {
      let spotRate = value != "" ? parseFloat(value) : "";
      let commodityCost =
        arrivalData != null
          ? arrivalData?.weightUnit == "RATE_PER_UNIT"
            ? Number(spotRate) * Number(arrivalData?.qty)
            : Number(spotRate) * Number(arrivalData?.netWeight)
          : "";
      let netWeight = arrivalData?.netWeight || "";
      let invoice =
        Number(commodityCost) +
        Number(arrivalData?.freightAmt) +
        Number(arrivalData?.misc);
      let landingRate = fixedDigitNumber(
        Number(invoice) /
          (arrivalData?.weightUnit == "RATE_PER_UNIT"
            ? Number(arrivalData?.qty)
            : Number(netWeight))
      );
      arrivalData = {
        ...arrivalData,
        destRate: Number(landingRate),
        netWeight: Number(netWeight),
        cmdityCost:
          Number(commodityCost) > 0
            ? numberPrecision(commodityCost)
            : Number(commodityCost),
        invAmt: Number(invoice),
        rate: Number(spotRate),
      };
    } else if (type === "FINALRATE") {
      let invoice =
        arrivalData != null
          ? arrivalData?.weightUnit == "RATE_PER_UNIT"
            ? parseFloat(value) * Number(arrivalData?.qty)
            : parseFloat(value) * Number(arrivalData?.netWeight)
          : "";
      let destRate = value != "" ? parseFloat(value) : "";
      let netWeight = arrivalData?.netWeight || "";
      let commodityCost =
        Number(invoice) -
        Number(arrivalData?.freightAmt) -
        Number(arrivalData?.misc);
      let rate = fixedDigitNumber(
        Number(commodityCost) /
          (arrivalData?.weightUnit == "RATE_PER_UNIT"
            ? Number(arrivalData?.qty)
            : Number(netWeight))
      );
      arrivalData = {
        ...arrivalData,
        destRate: Number(destRate),
        netWeight: Number(netWeight),
        cmdityCost:
          Number(commodityCost) > 0
            ? numberPrecision(commodityCost)
            : Number(commodityCost),
        invAmt: Number(invoice),
        rate: Number(rate),
      };
    } else if (type === "COMMODITYCOST") {
      let commodityCost = value !== "" ? parseFloat(value) : "";
      let rate =
        arrivalData != null
          ? arrivalData?.weightUnit === "RATE_PER_UNIT"
            ? parseFloat(
                (parseFloat(value) / Number(arrivalData?.qty)).toFixed(2)
              )
            : parseFloat(
                (parseFloat(value) / Number(arrivalData?.netWeight)).toFixed(2)
              )
          : "";
      let invoice;
      let destRate;
      // if (arrivalData?.rateType == "SPOT") {
      invoice =
        Number(commodityCost) +
        Number(arrivalData?.freightAmt) +
        Number(arrivalData?.misc);
      destRate =
        arrivalData != null
          ? arrivalData?.weightUnit === "RATE_PER_UNIT"
            ? parseFloat((invoice / Number(arrivalData?.qty)).toFixed(2))
            : parseFloat((invoice / Number(arrivalData?.netWeight)).toFixed(2))
          : "";
      // }
      arrivalData = {
        ...arrivalData,
        cmdityCost:
          Number(commodityCost) > 0
            ? numberPrecision(commodityCost)
            : Number(commodityCost),
        destRate: Number(destRate),
        invAmt:
          Number(invoice) > 0 ? numberPrecision(invoice) : Number(invoice),
        rate: Number(rate),
      };
    } else if (type === "MISC") {
      arrivalData = {
        ...arrivalData,
        misc: Number(value),
      };
    } else if (type === "INVOICECOST") {
      let invoice = value !== "" ? parseFloat(value) : "";
      let destRate =
        arrivalData != null
          ? arrivalData?.weightUnit === "RATE_PER_UNIT"
            ? parseFloat(
                (parseFloat(value) / Number(arrivalData?.qty)).toFixed(2)
              )
            : parseFloat(
                (parseFloat(value) / Number(arrivalData?.netWeight)).toFixed(2)
              )
          : "";
      let commodityCost = arrivalData?.cmdityCost;
      let rate = arrivalData?.rate || "";
      // if (arrivalData?.rateType == "SPOT") {
      commodityCost =
        Number(invoice) -
        Number(arrivalData?.freightAmt) -
        Number(arrivalData?.misc);
      rate =
        arrivalData != null
          ? arrivalData?.weightUnit === "RATE_PER_UNIT"
            ? parseFloat((commodityCost / Number(arrivalData?.qty)).toFixed(2))
            : parseFloat(
                (commodityCost / Number(arrivalData?.netWeight)).toFixed(2)
              )
          : "";
      // }
      arrivalData = {
        ...arrivalData,
        cmdityCost:
          Number(commodityCost) > 0
            ? numberPrecision(commodityCost)
            : Number(commodityCost),
        destRate: Number(destRate),
        invAmt:
          Number(invoice) > 0 ? numberPrecision(invoice) : Number(invoice),
        rate: Number(rate),
      };
    } else if (type === "COMMENTS") {
      arrivalData = {
        ...arrivalData,
        arlComments: value,
      };
    } else if (type === "DRIVERMOBILE") {
      arrivalData = {
        ...arrivalData,
        driverMobile: value,
      };
    } else if (type === "DRIVERNAME") {
      arrivalData = {
        ...arrivalData,
        driverName: value,
      };
    }
    dispatch(
      udpateAddArrival({
        arrival: arrivalData,
      })
    );
  };

  const onChangeDate = (date: string) => {
    dispatch(
      udpateAddArrival({
        arrival: {
          ...addArrivalDetails,
          arlDate: date,
        },
      })
    );
  };

  const onChangeTime = (time: string) => {
    dispatch(
      udpateAddArrival({
        arrival: {
          ...addArrivalDetails,
          arlTime: time,
        },
      })
    );
  };
  const updateArrivalCropLineItem = (id: number, field: string, value: any) => {
    const item = cropLineItems.find((i) => i.id === id);
    if (!item) return;

    switch (field) {
      case "destQty":
        return handleQtyAtDestChange(id, value, item);
      case "destWeight":
        return handleWeightAtDestChange(id, value, item);
      case "rate":
        return handleSpotRateChange(id, value, item);
      case "landingRate":
        return handleLandingRateChange(id, value, item);
      case "cmdityCost":
        return handleCropCommodityChange(id, value, item);
      case "invoiceAmt":
        return handleCropInvoiceChange(id, value, item);
      case "weightUnit":
        return handleCropRatePerUnitChange(id, value, item);
      default:
        return directArrivalCroValUpdate(id, field, value);
    }
  };
  const directArrivalCroValUpdate = (id: number, field: string, value: any) => {
    const updated = cropLineItems.map((item) =>
      item.id === id ? { ...item, [field]: value } : item
    );

    dispatch(setCropLineItems(updated));
  };
  const handleQtyAtDestChange = (id: number, value: string, item: TCrop) => {
    const qty = toNum(value);

    let updatedItems = cropLineItems.map((c) =>
      c.id === id ? { ...c, destQty: qty } : c
    );

    const newTotalQty = updatedItems.reduce(
      (sum, i) => sum + Number(i.destQty || 0),
      0
    );

    const totalWeight = updatedItems.reduce(
      (sum, i) => sum + Number(i.weight || 0),
      0
    );

    updatedItems = updatedItems.map((cropItem) => {
      let qtyVal = Number(cropItem.destQty || 0);
      let qtyNewVal = getIndWeight(
        Number(cropItem.weight),
        cropItem.weightUnit,
        qtyVal
      );

      const cropIndFreightRate = getArrivalIndFreightRate(
        addArrivalDetails?.rate,
        addArrivalDetails?.freightAmt,
        totalWeight,
        newTotalQty,
        cropItem.weightUnit
      );

      const indFreightCost = cropIndFreightRate * qtyNewVal;

      let spotRate = Number(cropItem.rate);
      let landingRate = Number(cropItem.landingRate);
      let commodityCost = Number(cropItem.cmdityCost);
      let invoiceAmt = Number(cropItem.invoiceAmt);

      if (cropItem.weightUnit === TRatePerTypes.unit) {
        if (addArrivalDetails?.rateType === "SPOT") {
          landingRate = spotRate + cropIndFreightRate;

          invoiceAmt = landingRate * qtyNewVal;
          commodityCost = spotRate * qtyNewVal;
        } else if (addArrivalDetails?.rateType === "LANDING") {
          spotRate = landingRate - cropIndFreightRate;
          commodityCost = spotRate * qtyNewVal;
          invoiceAmt = landingRate * qtyNewVal;
        }
      }

      return {
        ...cropItem,
        cmdityCost: commodityCost
          ? roundOffNum(commodityCost, 0)
          : commodityCost,
        rate: spotRate,
        landingRate,
        invoiceAmt: invoiceAmt ? roundOffNum(invoiceAmt, 0) : invoiceAmt,
      };
    });

    calcTotalArrivalInvoices(updatedItems, addArrivalDetails?.freightAmt);
  };

  const handleWeightAtDestChange = (id: number, value: string, item: TCrop) => {
    const newDestWeight = toNum(value);

    if (newDestWeight === "") {
      updateArrvalCropItem(id, { destWeight: "", netWeight: 0 });
      return;
    }

    let updatedItems = cropLineItems?.map((row: TCrop) =>
      row.id === id ? { ...row, destWeight: newDestWeight } : row
    );

    const newTotalWeight = updatedItems.reduce(
      (sum, c) => sum + Number(c.destWeight || 0),
      0
    );

    const newTotalQty = updatedItems.reduce(
      (sum, c) => sum + Number(c.destQty || 0),
      0
    );

    updatedItems = updatedItems.map((crop: TCrop) => {
      const destWeight = Number(crop.destWeight || 0);
      const qty = Number(crop.destQty || 0);

      const weight = getIndWeight(destWeight, crop.weightUnit, qty);

      const cropIndFreightRate = getArrivalIndFreightRate(
        addArrivalDetails?.rate,
        addArrivalDetails?.freightAmt,
        newTotalWeight,
        newTotalQty,
        crop.weightUnit
      );

      let spotRate = Number(crop.rate) || 0;
      let landingRate = Number(crop.landingRate) || 0;
      let commodityCost = Number(crop.cmdityCost) || 0;
      let invoiceAmt = Number(crop.invoiceAmt) || 0;

      if (addArrivalDetails?.rateType === "SPOT") {
        landingRate = spotRate + cropIndFreightRate;
        invoiceAmt = landingRate * weight;
        commodityCost = spotRate * weight;
      } else if (addArrivalDetails?.rateType === "LANDING") {
        spotRate = landingRate - cropIndFreightRate;
        commodityCost = spotRate * weight;
        invoiceAmt = landingRate * weight;
      }
      console.log(landingRate, cropIndFreightRate, spotRate);
      const moistureLoss = destWeight ? Number(crop.weight) - destWeight : 0;
      const netWeight = Number(destWeight) || 0;

      return {
        ...crop,
        destWeight,
        cmdityCost: commodityCost
          ? roundOffNum(commodityCost, 0)
          : commodityCost,
        invoiceAmt: invoiceAmt ? roundOffNum(invoiceAmt, 0) : invoiceAmt,
        landingRate: numberPrecision(landingRate),
        rate: numberPrecision(spotRate),
        netWeight,
        moistureLoss,
        destQty: qty,
      };
    });

    calcTotalArrivalInvoices(updatedItems, addArrivalDetails?.freightAmt);
  };
  const handleLandingRateChange = (id: number, value: string, item: TCrop) => {
    const landingRateVal = toNum(value);

    if (landingRateVal === "") {
      updateArrvalCropItem(id, { landingRate: "" });
      return;
    }
    let updatedItems = cropLineItems?.map((row: TCrop) =>
      row.id === id ? { ...row, landingRate: landingRateVal } : row
    );

    const newTotalWeight = updatedItems.reduce(
      (sum, c) => sum + Number(c.destWeight || 0),
      0
    );

    const newTotalQty = updatedItems.reduce(
      (sum, c) => sum + Number(c.destQty || 0),
      0
    );

    let spotRate = Number(item.rate) || 0;
    let qty = Number(item?.destQty) || 0;
    let destWeight = Number(item?.destWeight) || 0;
    const weight = getIndWeight(destWeight, item.weightUnit, qty);

    const cropIndFreightRate = getArrivalIndFreightRate(
      addArrivalDetails?.rate,
      addArrivalDetails?.freightAmt,
      newTotalWeight,
      newTotalQty,
      item.weightUnit
    );
    let commodityCost = Number(item?.cmdityCost) || 0;
    let invoiceAmt = Number(item?.invoiceAmt) || 0;

    spotRate = landingRateVal - cropIndFreightRate;
    commodityCost = spotRate * weight;
    invoiceAmt = landingRateVal * weight;
    updateArrvalCropItem(id, {
      rate: spotRate,
      destWeight: destWeight,
      cmdityCost: commodityCost ? roundOffNum(commodityCost, 0) : commodityCost,
      invoiceAmt: invoiceAmt ? roundOffNum(invoiceAmt) : invoiceAmt,
      landingRate: landingRateVal,
    });
  };
  const handleSpotRateChange = (id: number, value: string, item: TCrop) => {
    const spotRateVal = toNum(value);

    if (spotRateVal === "") {
      updateArrvalCropItem(id, { rate: "" });
      return;
    }
    let updatedItems = cropLineItems?.map((row: TCrop) =>
      row.id === id ? { ...row, rate: spotRateVal } : row
    );

    const newTotalWeight = updatedItems.reduce(
      (sum, c) => sum + Number(c.destWeight || 0),
      0
    );

    const newTotalQty = updatedItems.reduce(
      (sum, c) => sum + Number(c.destQty || 0),
      0
    );

    let landingRate = Number(item.landingRate) || 0;
    let qty = Number(item?.destQty) || 0;
    let destWeight = Number(item?.destWeight) || 0;
    const weight = getIndWeight(destWeight, item.weightUnit, qty);

    const cropIndFreightRate = getArrivalIndFreightRate(
      addArrivalDetails?.rate,
      addArrivalDetails?.freightAmt,
      newTotalWeight,
      newTotalQty,
      item.weightUnit
    );
    let commodityCost = Number(item?.cmdityCost) || 0;
    let invoiceAmt = Number(item?.invoiceAmt) || 0;

    landingRate = spotRateVal + cropIndFreightRate;
    invoiceAmt = landingRate * weight;
    commodityCost = spotRateVal * weight;

    updateArrvalCropItem(id, {
      rate: spotRateVal,
      // weight,
      cmdityCost: commodityCost ? roundOffNum(commodityCost, 0) : commodityCost,
      invoiceAmt: invoiceAmt ? roundOffNum(invoiceAmt) : invoiceAmt,
      landingRate: landingRate,
    });
  };
  const handleCropCommodityChange = (
    id: number,
    value: string,
    item: TCrop
  ) => {
    const commodityVal = toNum(value) ?? 0;
    // if (commodityVal === "") {
    //   updateCropItem(id, { cmdityCost: "" });
    //   return;
    // }
    let spotRate = Number(item?.rate) || 0;
    let landingRate = Number(item?.landingRate) || 0;
    let qty = Number(item.destQty) || 0;
    let updatedItems = cropLineItems?.map((row: TCrop) =>
      row.id === id ? { ...row, cmdityCost: commodityVal } : row
    );

    const newTotalWeight = updatedItems.reduce(
      (sum, c) => sum + Number(c.destWeight || 0),
      0
    );

    const newTotalQty = updatedItems.reduce(
      (sum, c) => sum + Number(c.destQty || 0),
      0
    );
    let invoiceAmt = Number(item?.invoiceAmt) || 0;
    const cropIndFreightRate = getArrivalIndFreightRate(
      addArrivalDetails?.rate,
      addArrivalDetails?.freightAmt,
      newTotalWeight,
      newTotalQty,
      item.weightUnit
    );
    let destWeight = Number(item?.destWeight) || 0;
    const weight = getIndWeight(destWeight, item.weightUnit, qty);
    spotRate = getIndSpotRate(Number(commodityVal), weight);
    landingRate = spotRate + cropIndFreightRate;
    invoiceAmt = landingRate * weight;
    updateArrvalCropItem(id, {
      rate: spotRate,
      cmdityCost: commodityVal ? roundOffNum(commodityVal, 0) : commodityVal,
      invoiceAmt: invoiceAmt ? roundOffNum(invoiceAmt) : invoiceAmt,
      landingRate: landingRate,
    });
  };
  const handleCropInvoiceChange = (id: number, value: string, item: TCrop) => {
    let invoiceAmt = toNum(value) ?? 0;

    // if (invoiceAmt === "") {
    //   updateCropItem(id, { invoiceAmt: "" });
    //   return;
    // }
    let spotRate = Number(item?.rate) || 0;
    let landingRate = Number(item?.landingRate) || 0;
    let qty = Number(item.destQty) || 0;
    let updatedItems = cropLineItems?.map((row: TCrop) =>
      row.id === id ? { ...row, invoiceAmt: invoiceAmt } : row
    );

    const newTotalWeight = updatedItems.reduce(
      (sum, c) => sum + Number(c.destWeight || 0),
      0
    );

    const newTotalQty = updatedItems.reduce(
      (sum, c) => sum + Number(c.destQty || 0),
      0
    );
    const cropIndFreightRate = getArrivalIndFreightRate(
      addArrivalDetails?.rate,
      addArrivalDetails?.freightAmt,
      newTotalWeight,
      newTotalQty,
      item.weightUnit
    );
    let destWeight = Number(item?.destWeight) || 0;
    const weight = getIndWeight(destWeight, item.weightUnit, qty);
    let commodityVal = Number(item?.cmdityCost) || 0;
    landingRate = getIndLandingRate(Number(invoiceAmt), weight);
    spotRate = landingRate - cropIndFreightRate;
    commodityVal = spotRate * weight;
    invoiceAmt = landingRate * weight;

    updateArrvalCropItem(id, {
      rate: spotRate ? numberPrecision(spotRate) : spotRate,
      cmdityCost: commodityVal ? roundOffNum(commodityVal, 0) : commodityVal,
      invoiceAmt: invoiceAmt ? roundOffNum(invoiceAmt) : invoiceAmt,
      landingRate: landingRate,
    });
  };
  const handleCropRatePerUnitChange = (
    id: number,
    value: string,
    item: TCrop
  ) => {
    const weightUnit = value;

    if (weightUnit === "") {
      updateArrvalCropItem(id, { weightUnit: "" });
      return;
    }

    updateArrvalCropItem(id, { weightUnit });
    const updatedItems = cropLineItems.map((crop) =>
      crop.id === id ? { ...crop, weightUnit } : crop
    );
    const newTotalWeight = updatedItems.reduce(
      (sum, c) => sum + Number(c.destWeight || 0),
      0
    );

    const newTotalQty = updatedItems.reduce(
      (sum, c) => sum + Number(c.destQty || 0),
      0
    );
    const recalculatedItems = updatedItems.map((crop) => {
      let spotRate = Number(crop.rate) || 0;
      let destWeight = Number(crop.destWeight) || 0;
      let qty = Number(crop.destQty) || 0;
      let landingRate = Number(crop.landingRate) || 0;

      const cropIndFreightRate = getArrivalIndFreightRate(
        addArrivalDetails?.rate,
        addArrivalDetails?.freightAmt,
        newTotalWeight,
        newTotalQty,
        weightUnit
      );
      let commodityCost = Number(crop.cmdityCost) || 0;
      const weight = getIndWeight(destWeight, weightUnit, qty);
      let invoiceAmt = Number(crop.invoiceAmt) || 0;
      if (addArrivalDetails?.rateType === "SPOT") {
        landingRate = spotRate + cropIndFreightRate;
        invoiceAmt = landingRate * weight;
        commodityCost = spotRate * weight;
      } else if (addArrivalDetails?.rateType === "LANDING") {
        spotRate = landingRate - cropIndFreightRate;
        commodityCost = spotRate * weight;
        invoiceAmt = landingRate * weight;
      }
      // if (tradeDetailsbyId?.rateType === "SPOT") {
      //   commodityCost = getIndSpotCommodityCost(
      //     spotRate,
      //     weight,
      //     weightUnit,
      //     qty
      //   );
      //   invoiceAmt = commodityCost + cropIndFreightCost.indFreightCost;
      //   landingRate = getIndLandingRate(
      //     invoiceAmt,
      //     getIndWeight(weight, weightUnit, qty)
      //   );
      // } else if (tradeDetailsbyId?.rateType === "LANDING") {
      //   invoiceAmt = getIndLandingInvoiceCost(
      //     landingRate,
      //     weight,
      //     weightUnit,
      //     qty
      //   );
      //   commodityCost = invoiceAmt - cropIndFreightCost.indFreightCost;
      //   spotRate = getIndSpotRate(
      //     commodityCost,
      //     getIndWeight(weight, weightUnit, qty)
      //   );
      // }

      return {
        ...crop,
        cmdityCost: commodityCost
          ? roundOffNum(commodityCost, 0)
          : commodityCost,
        invoiceAmt: invoiceAmt ? roundOffNum(invoiceAmt) : invoiceAmt,
        rate: spotRate ? numberPrecision(spotRate) : spotRate,
        landingRate: landingRate ? numberPrecision(landingRate) : landingRate,
        weightUnit,
        unitType: weightUnit,
      };
    });

    calcTotalArrivalInvoices(recalculatedItems, addArrivalDetails?.freightAmt);
  };
  const updateArrvalCropItem = (
    id: number,
    changes: Partial<TCrop>,
    totalFreightAmt?: number
  ) => {
    const totalFreight = totalFreightAmt
      ? totalFreightAmt
      : Number(addArrivalDetails.freightAmt);
    const items = cropLineItems.map((it) =>
      it.id === id ? { ...it, ...changes } : it
    );

    calcTotalArrivalInvoices(items, totalFreight);
  };
  const calcTotalArrivalInvoices = (
    updatedItems: TCrop[],
    totalFreight: number,
    freightRate?: number,
    freightRateUnit?: string
  ) => {
    const finalRows = updatedItems;
    const totalWeight = finalRows.reduce(
      (s, r) => s + Number(r.destWeight || 0),
      0
    );
    const totalQty = finalRows.reduce((s, r) => s + Number(r.destQty || 0), 0);
    const totalCommodity = finalRows.reduce(
      (s, r) => s + Number(r.cmdityCost || 0),
      0
    );
    const totalNetWeight = finalRows.reduce(
      (s, r) => s + Number(r.netWeight || 0),
      0
    );
    const totalInvoice =
      totalCommodity + addArrivalDetails?.freightAmt + addArrivalDetails?.misc;

    dispatch(setCropLineItems(finalRows));
    dispatch(
      udpateAddArrival({
        arrival: {
          ...addArrivalDetails,
          cmdityCost: totalCommodity,
          invAmt: totalInvoice,
          freightAmt: numberPrecision(totalFreight),
          totalWeight,
          rate: freightRate ?? addArrivalDetails?.rate,
          totalQty: totalQty,
          rateUnit: freightRateUnit ?? addArrivalDetails?.rateUnit,
          totalNetWeight: totalNetWeight
            ? numberPrecision(totalNetWeight)
            : totalNetWeight,
        },
      })
    );
  };
  return {
    updateArrivalData,
    onUploadReceiptImage1,
    onRemoveReceiptImage1,
    calenderOpen,
    setCalenderOpen,
    arlDate,
    paymentHistoryObj,
    reqAdvInfo,
    setReqAdvInfo,
    role,
    isArrivalEdit,
    setIsArrivalEdit,
    pattiDocsEdit,
    setPattiDocsEdit,
    calculateAdvancePaid,
    calculateAdvancePaidSrc,
    onUpdateArrivalInput,
    onChangeTime,
    onChangeDate,
    cropLineItems,
    updateArrivalCropLineItem,
  };
};

export default useArrivalDetails;
